import { isNullOrUndefined } from "./storeFunctions";
import { writeErr } from '../components/common/logger';

let themeCss = undefined;

const themeRegex = /(theme-)(\w+)(\.css)($|.*([]|(v=\d+)))/i

const skins = [
    { code: "red", color: "#fff", default: true },
    { code: "blue", color: "#fff", default: false },
    { code: "dark", color: "#1f2123", default: false },
];

const currentSettings = {
    user: {
        theme: undefined,
        tint: undefined,
        reportHeadersStyles: undefined,
        popupHeaderStyle: undefined
    },
    web: {
        theme: localStorage.locales_theme,
        reportHeadersStyles: localStorage.locales_report_headers_style,
        tint: localStorage.locales_tint,
        popupHeaderStyle: localStorage.locales_popup_header_style,
        fontSize: localStorage.font_size,
        font: localStorage.font,
        buttonStyle: localStorage.locales_button_style,
        menuActiveStyle: localStorage.locales_menu_active_style,
        urlFormat: localStorage.locales_url_format,
        reportWidth: localStorage.locales_report_width,
        reportButtonsFormat: localStorage.locales_report_buttons_format
    }
}

const hookListener = function(store) {
    store.subscribe(() => storeListener(store));
    window.addEventListener('storage', (event) => {
        store.dispatch({ type: 'STORAGE_CHANGED', key:event.key });
    });
}

const setupTheme = function() {
    if(themeCss === undefined) {
        themeCss = document.getElementById('theme-css');
    }

    readUserTheme()
    let theme = !isNullOrUndefined(localStorage.locales_theme) && localStorage.locales_theme !== "undefined"
        ? localStorage.locales_theme
        : !isNullOrUndefined(currentSettings.user.theme) ? currentSettings.user.theme : skins.filter(x => x.default)[0].code;
    setNewTheme(theme);
}

const setupFontSize = function() {
    if(!localStorage.font_size) {
        localStorage.setItem('font_size', '14px');
    }
    setNewFontSize(localStorage.font_size);
}

const setupFont = function() {
    if(!localStorage.font) {
        localStorage.setItem('font', 'montserrat');
    }
    setNewFont(localStorage.font);
}

const storeListener = function(store) {
    if(currentSettings.web.theme !== localStorage.locales_theme) {
        setNewTheme(localStorage.locales_theme);
        currentSettings.web.theme = localStorage.locales_theme;
    }
    if(currentSettings.web.fontSize !== localStorage.font_size) {
        setNewFontSize(localStorage.font_size);
        currentSettings.web.fontSize = localStorage.font_size;
    }
    if(currentSettings.web.reportWidth !== localStorage.locales_report_width) {
        setReportWidth(localStorage.locales_report_width);
        currentSettings.web.reportWidth = localStorage.locales_report_width;
    }
    if(currentSettings.web.font !== localStorage.font) {
        setNewFont(localStorage.font);
        currentSettings.web.font = localStorage.font;
    }
}

const readUserTheme = function() {
    try {
        let json = JSON.parse(localStorage.auth);
        currentSettings.user.theme = json.profile.displaySettings.theme;
        currentSettings.user.tint = json.profile.displaySettings.tint;
        currentSettings.user.reportHeadersStyle = json.profile.displaySettings.reportHeadersStyle;
        currentSettings.user.popupHeaderStyle = json.profile.displaySettings.popupHeaderStyle;
        currentSettings.user.urlFormat = json.profile.displaySettings.urlFormat;
        currentSettings.user.menuActiveStyle = json.profile.displaySettings.menuActiveStyle;
        currentSettings.user.buttonStyle = json.profile.displaySettings.buttonStyle;
        currentSettings.user.reportWidth = json.profile.displaySettings.reportWidth;
        currentSettings.user.reportButtonsFormat = json.profile.displaySettings.reportButtonsFormat;
    } catch (error) {
        writeErr(error);
    }
}

const setNewTheme = function(theme) {
    const newLink = themeCss.href.replace(themeRegex, function (match, p1,p2,p3,p4,p5) {
        if(p1 === 'theme-' && p2 !== theme && p3 === '.css') {
            return p1+theme+p3+'?v='+Date.now();
        } else if (p5 === '' || p5 === undefined) {
            return p1+p2+p3+'?v='+Date.now();
        }
        return match;
    });

    if(themeCss.href !== newLink) {
        themeCss.href = newLink;
    }
}

const setNewFontSize = function(size) {
    const items = document.documentElement.className.split(' ').filter(x => x.startsWith('fontSize-'));
    for (let idx = 0; idx < items.length; idx++) {
        document.documentElement.classList.remove(items[idx]);
    }
    document.documentElement.classList.add('fontSize-'+size);
}

const setNewFont = function(font) {
    const items = document.documentElement.className.split(' ').filter(x => x.startsWith('font-'));
    for (let idx = 0; idx < items.length; idx++) {
        document.documentElement.classList.remove(items[idx]);
    }
    document.documentElement.classList.add('font-'+font);
}

const setReportWidth = function(widthClass) {
    if (widthClass === 'full')
        document.body.classList.add('full-report-width');
    else
        document.body.classList.remove('full-report-width');
}

export { setupTheme, setupFontSize, setupFont, hookListener, skins };